/**
 * Static site form handlers
 * Posts to Cloudflare Workers instead of Umbraco surface controllers
 */

// Functions are deployed alongside the static site at the same origin
const FUNCTIONS_URL = '/api';

// Contact form handler
function initContactForm() {
  const form = document.querySelector('[data-static-form="contact"]');
  if (!form) return;

  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    const submitBtn = form.querySelector('[type="submit"]');
    const originalText = submitBtn.value;
    submitBtn.value = 'Sending...';
    submitBtn.disabled = true;

    try {
      const formData = new FormData(form);

      const response = await fetch(`${FUNCTIONS_URL}/contact`, {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();

      if (result.success) {
        form.innerHTML = '<p class="o-form__success">Thanks! Your message has been successfully sent.</p>';
      } else {
        showError(form, result.error || 'Failed to send message. Please try again.');
        submitBtn.value = originalText;
        submitBtn.disabled = false;
      }
    } catch (error) {
      console.error('Contact form error:', error);
      showError(form, 'An error occurred. Please try again.');
      submitBtn.value = originalText;
      submitBtn.disabled = false;
    }
  });
}

// Painting submission form handler
function initSubmissionForm() {
  const form = document.querySelector('[data-static-form="painting-submission"]');
  if (!form) return;

  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    const submitBtn = form.querySelector('[type="submit"]');
    const originalText = submitBtn.value;
    submitBtn.value = 'Uploading...';
    submitBtn.disabled = true;

    try {
      const formData = new FormData(form);

      // Add gallery name from page context if available
      const galleryName = form.dataset.galleryName || document.title;
      formData.append('GalleryName', galleryName);

      const response = await fetch(`${FUNCTIONS_URL}/painting-submission`, {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();

      if (result.success) {
        form.innerHTML = `
          <p class="o-form__success">Thanks! Your artwork has been submitted successfully.</p>
          <p>It will be reviewed and added to the gallery soon.</p>
          <button type="button" class="o-btn" onclick="location.reload()">Submit another entry</button>
        `;
      } else {
        showError(form, result.error || 'Failed to submit artwork. Please try again.');
        submitBtn.value = originalText;
        submitBtn.disabled = false;
      }
    } catch (error) {
      console.error('Submission form error:', error);
      showError(form, 'An error occurred. Please try again.');
      submitBtn.value = originalText;
      submitBtn.disabled = false;
    }
  });
}

function showError(form, message) {
  // Remove existing error
  const existingError = form.querySelector('.o-form__error');
  if (existingError) existingError.remove();

  // Add new error
  const errorDiv = document.createElement('div');
  errorDiv.className = 'o-form__error';
  errorDiv.textContent = message;
  form.insertBefore(errorDiv, form.firstChild);
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

function init() {
  initContactForm();
  initSubmissionForm();
}
